import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useLocation, useParams } from 'react-router-dom';
import SurveySubmit from './SurveySubmit';

const useQuery = () => new URLSearchParams(useLocation().search);

const SurveyNav = ({ onSubmit }) => {
  const { t } = useTranslation('commons');
  const { page: pageStr } = useParams();
  const questions = useSelector(state => state.questions);
  const answers = useSelector(state => state.answers);
  const questionsCount = questions[1].length;
  const answersCount = questions[1].filter(q => answers[q] != null).length;
  const numPages = Object.keys(questions).length;
  const page = pageStr ? parseInt(pageStr) : 1;
  const disableNext = page === 1 && answersCount !== questionsCount;
  const queryString = useQuery().toString();
  const buildPagePath = (location, page) => `${location.pathname.replace(/\/\d$/, '')}/${page}?${queryString}`;
  return (
    <div>
      { page > 1 && (
        <Link
          to={location => buildPagePath(location,page - 1)}
          className="mr-2 btn btn-light">{t('navigation.back')}</Link>
      ) }
      { page < numPages && (
        <Link
          to={location => buildPagePath(location, page + 1)}
          className={`btn btn-primary ${disableNext ? 'disabled' : ''}`}>{t('navigation.next')}</Link>
      ) }
      { page === numPages && (
        <SurveySubmit />
      ) }
    </div>
  );
};

export default SurveyNav;
